import clsx from 'clsx'
import { FC, useEffect } from 'react'
import { toAbsoluteUrl } from '../../../helpers'
import { Inbox, MessageSquare, ArrowRight } from 'lucide-react'
import { useIntl } from 'react-intl'
import ConvertDate from '../../../../Utils/ConvertDate'
import { useLang } from '../../../i18n/Metronici18n'
import { useNotifications, useMarkNotificationRead, useMarkAllNotificationsRead } from '../../../../hooks/queries'
import { useAuthStore } from '../../../../store/authStore'
const HeaderNotificationsMenu: FC = () => {
  const isNotification = useAuthStore((state) => state.newNotification)
  const lang = useLang()?.lang.selectedLang
  const { data, isLoading: loading, refetch } = useNotifications()
  const { mutate: markAsRead } = useMarkNotificationRead()
  const { mutate: markAllAsRead } = useMarkAllNotificationsRead()

  // Refetch when notification flag changes
  useEffect(() => {
    if (isNotification) {
      refetch()
    }
  }, [isNotification, refetch])

  const intl = useIntl()
  return (
    <div
      className='w-350px w-lg-375px menu menu-sub menu-sub-dropdown menu-column'
      data-kt-menu='true'
    >
      <div
        className='shadow-lg border-0 card'
        style={{
          width: '380px',
          borderRadius: '15px',
        }}
      >
        <div
          className='d-flex justify-content-center align-items-center text-center text-white card-header'
          style={{
            background: 'linear-gradient(135deg, #7D5BC8 0%, #5C37A9 100%)',
            borderRadius: '15px 15px 0 0',
          }}
        >
          <h1 className='mb-0 text-white fw-bold'>{intl.formatMessage({ id: 'Notifications' })}</h1>
        </div>
        <hr className='m-0' />

        <div className={`${loading && 'skeleton'}`}>
          <div className='my-5 px-8 min-h-100px scroll-y mh-325px'>
            {data && data.results.map((alert, index: number) => (
              <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                <div className='d-flex flex-column gap-2'>
                  <div className='d-flex align-items-center gap-2 symbol symbol-35px'>
                    <span
                      className={clsx(
                        'symbol-label',
                        `bg-light-${alert?.is_read ? 'primary' : 'warning'}`
                      )}
                    >
                      {' '}
                      {alert.is_read
                        ? <Inbox size={22} className={`text-primary`} />
                        : <MessageSquare size={22} className={`text-warning`} />
                      }
                    </span>
                    <a href={alert.link || '#'} className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                      {lang === "fa" ? alert?.title_fa || alert?.title : alert?.title}
                    </a>
                  </div>

                  <div className='mb-0 me-2'>
                    <div className='text-gray-500 fs-6'>{lang === "fa" ? alert?.description_fa || alert?.description : alert?.description}</div>
                  </div>
                  <span className='p-1 badge badge-light fs-7' style={{ width: "fit-content" }}>
                    <ConvertDate date={alert?.created_at} />
                  </span>
                </div>

              </div>
            ))}
          </div>

          {/* <div className='py-3 border-top text-center'>
            <Link
              to='/crafted/pages/profile'
              className='btn btn-color-gray-600 btn-active-color-primary'
            >
              {intl.formatMessage({id: 'View All'})}
              <ArrowRight size={16} />
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }
